import {IBooking, IReplicateSubscription} from "shared-types/index";

export interface IInheritedError {
  status: number;
}

export interface InitialReplicateFromProps {
  dbLocal: PouchDB.Database;
  syncLogStack: string[];
  serverLoggingDbEvents: (message: string, logType: string, logNotes: string) => void;
  // REMOVED replicateSubscriptions and placed it in class variable (call setReplicateSubscriptions first)
  initialReplicaChangeCallback: (value: { total: number; current: number }) => void; // to replace $rootScope.$broadcast('pouch-initial-replica-change'
  upToDateWithRemoteCallback: () => void; // to replace $rootScope.$broadcast('uptodate-with-remote');
  unauthorisedCallback: () => void;
  reducedInfo: { url: string; username: string; password: string };
  remoteDBDocsCount: number;
  isOnlineCreated: boolean;
  retryCount: number;
  inheritedResolve?: (value?: unknown) => void;
  inheritedReject?: (reason?: any) => void;
  inheritedError?: IInheritedError | string;
}

export interface ILiveSync {
  dbLocal: PouchDB.Database;
  syncLogStack: string[];
  // REMOVED replicateSubscriptions and placed it in class variable (call setReplicateSubscriptions first)
  reducedInfo: { url: string; username: string; password: string };
  handleReplicationFrom: (eventType: ReplicationEventType, info?: any) => void;
  handleReplicationTo: (eventType: ReplicationEventType, info?: any) => void;
}

export enum ReplicationEventType {
  uptodate = 'uptodate',
  error = 'error',
  change = 'change',
  // offline = 'offline',
}
export interface IReplicationDoc {
  _id: string;
  _deleted: boolean;
}

export interface IPouchUpdateParams {
  existingBookings: IBooking[];
  documentIds: string[];
  selectedDate: Date;
  actionValueCallback?: (action: IPouchChangeAction) => void;
  blockoutsCallback?: () => void;
}


export interface IPouchChangeAction {
  actionName: PouchActionsNames;
  value: any;
}

export enum PouchActionsNames {
  POUCH_SYNCED_DOCTYPE_TAG = 'pouch-synced-doctype-tag',
  POUCH_SYNCED_DOCTYPE_BOOKING = 'pouch-synced-doctype-booking',
  RECEIVE_CHANGE = 'receive-change',
  POUCH_SYNCED_DOCTYPE_EVENT = 'pouch-synced-doctype-event',
  POUCH_SYNCED_DOCTYPE_LAYOUT = 'pouch-synced-doctype-layout',
  POUCH_SYNCED_DOCTYPE_STATUS = 'pouch-synced-doctype-status',
  POUCH_SYNCED_DOCTYPE_NOTE = 'pouch-synced-doctype-note',
  POUCH_SYNCED_DOCTYPE_BLOCKOUT = 'pouch-synced-doctype-blockout',
  POUCH_SYNCED_DOCTYPE_SCHEDULE = 'pouch-synced-doctype-schedule',
  POUCH_SYNCED_DOCTYPE_SECTION = 'pouch-synced-doctype-section',
  POUCH_SYNCED_DOCTYPE_TABLE = 'pouch-synced-doctype-table',
  POUCH_SYNCED_DOCTYPE_SECTION_GROUP = 'pouch-synced-doctype-section-group',
  POUCH_SYNCED_DOCTYPE_SERVICE_GROUP = 'pouch-synced-doctype-service-group',
  //  add names for all 'pouch-synced-doctype-' events (booking, layout, status, note, blockout, event, schedule, section, table, section-group, service-group. severity: low
}
